import { FrameService } from '../../frame/frame.service';
import { Scenes } from '../models/scenes.enum';
import { Scene } from '../models/scene.model';
import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, NgZone } from '@angular/core';
import Marzipano from 'marzipano';
import { scenesLinks } from '../../../assets/config/scenes-data';
import { Subscription } from 'rxjs';
import { RenderService } from '../services/render.service';


@Component({
  selector: 'app-tour',
  templateUrl: './tour.component.html',
  styleUrls: ['./tour.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourComponent implements OnInit, AfterViewInit {

  scenesLinks = scenesLinks;
  subscription: Subscription;
  view: Marzipano.RectilinearView;

  currentIndex;
  hideLoading = false;
  pointer: any;
  tour: { viewer?, geometry? } = {};
  scenes: Array<any> = [];
  // for the check click mousedown / mouseup position and time
  mousePosition = { x: 0, y: 0 };
  mouseClickedTime: number;
  mobile = window.innerWidth < 1000;

  constructor(
      private frameService: FrameService,
      private renderService: RenderService,
      private cdr: ChangeDetectorRef,
      public zone: NgZone
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.hideLoading = true;
    this.initView();
    this.generateScenes();
    this.switchInitialScene();
  }

  initView() {
    const viewerOpts = {
      controls: {
        mouseViewMode: 'drag'    // drag|qtvr
      }
    };
    const panoElement = document.getElementById('pano');
    this.tour.viewer = new Marzipano.Viewer(panoElement, viewerOpts);

    const mobileLevels = [
      {
        tileSize: 256,
        size: 256,
        fallbackOnly: true
      },
      {
        tileSize: 512,
        size: 512
      },
      {
        tileSize: 512,
        size: 1024
      },
      {
        tileSize: 512,
        size: 2048
      }
    ];
    const desktoplevels = [
      { tileSize: 256, size: 256, fallbackOnly: true },
      { tileSize: 512, size: 512 },
      { tileSize: 512, size: 1024 },
      { tileSize: 512, size: 2048 },
      { tileSize: 512, size: 4096 }
    ];
    this.tour.geometry = new Marzipano.CubeGeometry(this.mobile ? mobileLevels : desktoplevels);
  }

  switchInitialScene(): void {
    this.renderService.selectedScene.subscribe((scene: Scenes) => {
      this.currentIndex = scene;
      this.cdr.detectChanges();
      this.loadScene(null, scene);
    });
  }

  getScene(index: number): { scene: Scene, view: any, data: any } {
    const sceneData = scenesLinks[index];

    // const url = `${environment.tour}tiles/${this.mobile ? 'mobile' : 'desktop'}/scene-${index}`;
    const url = `/assets/tiles/scene_${index}`;
    // const url = `${environment.tour}tiles/scene-${index}`;
    // const url = `assets/tiles/${this.mobile ? 'mobile' : 'desktop'}/scene-${index}`;
    const source = Marzipano.ImageUrlSource.fromString(
        `${url}/{z}/{f}/{y}/{x}.jpg`,
        { cubeMapPreviewUrl: `${url}/preview.jpg` });

    if (!sceneData.initialState.fov){
      sceneData.initialState.fov = 80 * Math.PI/180;
    }
    const limiter = Marzipano.RectilinearView.limit.traditional(
        3500, sceneData.initialState.fov, 180 * Math.PI / 180);
    // const view = new Marzipano.RectilinearView(sceneData.initialState, limiter);
    this.view = new Marzipano.RectilinearView(sceneData.initialState, limiter);

    const scene = this.tour.viewer.createScene({
      source: source,
      geometry: this.tour.geometry,
      view: this.view,
      pinFirstLevel: true
    });

    return {
      data: sceneData,
      scene,
      view: this.view,
    };
  }

  generateScenes() {
    this.scenes = this.scenesLinks.map((data: any, index: number) => this.getScene(index));
  }

  loadScene($event, index: Scenes): void {

    if (!!$event) {
      $event.stopPropagation();
      $event.stopImmediatePropagation();
    }


    // if drag - ignore click: start position difference more than 3 or time press more than 0.5s
    if (
        (Math.abs(this.mousePosition.x - $event?.screenX) > 3
            || Math.abs(this.mousePosition.y - $event?.screenY) > 3
            || Math.abs(this.mouseClickedTime - new Date().getTime()) > 500)
        && $event !== null
    ) {
      return;
    }
    this.currentIndex = index;
    const scene = this.scenes[index];


    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    scene.view.setParameters(scene.data.initialState);
    scene.scene.switchTo(
        {
          transitionDuration: 1000,
        }
    );

    setTimeout( () => this.addPointers(scene.scene, scene.data.pointers), 0);
    setTimeout( () => this.addIframeLinks(scene.scene, scene.data.frames), 0);
    // setInterval( () => this.addIframeLinks(scene, sceneData.frames), 500);
  }

  loadFrame($event, frame: any): void {
    // if drag - ignore click: start position difference more than 3 or time press more than 0.5s
    if ($event &&
        (Math.abs(this.mousePosition.x - $event.screenX) > 3
            || Math.abs(this.mousePosition.y - $event.screenY) > 3
            || Math.abs(this.mouseClickedTime - new Date().getTime()) > 500)
    ) {
      return;
    }
    this.frameService.show(frame);
  }

  onMouseDown($event: PointerEvent): void {
    this.mousePosition.x = $event.screenX;
    this.mousePosition.y = $event.screenY;
    this.mouseClickedTime = new Date().getTime();
  }

  private addPointers(scene: Scene, pointers: Array<any> ) {
    if (!pointers || !pointers.length) {
      return;
    }
    const container = scene.hotspotContainer();
    pointers.forEach((pointer: any, index: number) => {
      const element = document.querySelector(`#pointer-${this.currentIndex}-${index}`) as HTMLElement;
      container.createHotspot(element, pointer);
    });
  }

  private addIframeLinks(scene: Scene, frames: Array<any> ) {
    if (!frames || !frames.length) {
      return;
    }
    const container = scene.hotspotContainer();

    console.log(frames);
    frames.forEach((frame: any, index: number) => {
      const element = document.querySelector(`#frame-${this.currentIndex}-${index}`);

      frame.transformations.perspective.radius = 750;
      container.createHotspot(element, frame.position, frame.transformations);
    });
  }
}

